import { createContext, useContext } from 'react'

import { type TrackingSource } from './models'

export const TrackingSourceContext = createContext<TrackingSource | null>(null)

export const useTrackingSource = () => useContext(TrackingSourceContext)
